import { Dialog } from '@mui/material';
import { styled } from '@mui/system';

export const StyledDialog = styled(Dialog)(({ theme }) => ({
  '.MuiDialog-paper': {
    width: 'calc(100% - 16px * 2)',
    margin: '16px',
  },
}));
